import React from 'react';
import PropTypes from 'prop-types';

// Circular match-score gauge. `color` is any CSS color (pass a DS token var
// so it adapts to light/dark). The unfilled remainder renders in the shared
// muted-foreground token — visible as a full ring rather than a bare arc,
// so a low score still reads as "a ring, mostly empty" instead of "a
// fragment." SVG stroke-dasharray/dashoffset, not a CSS conic-gradient —
// the gradient approach silently fails to paint in some cases, this doesn't.
const ScoreRing = ({ score, color, size }) => {
  const stroke = 4;
  const r = (size - stroke * 2 - 2) / 2;
  const cx = size / 2;
  const circumference = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, score)) / 100;
  const offset = circumference * (1 - pct);

  return (
    <div className="relative shrink-0" style={{ width: size, height: size }}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        <circle
          cx={cx}
          cy={cx}
          r={r}
          fill="none"
          stroke="#d8dbe0"
          strokeWidth={stroke}
        />
        <circle
          cx={cx}
          cy={cx}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{
            transition: 'stroke-dashoffset .6s cubic-bezier(.4,0,.2,1)',
          }}
        />
      </svg>
      <div
        className="absolute inset-0 flex items-center justify-center text-[16px] font-bold tabular-nums tracking-[-0.02em]"
        style={{ color }}
      >
        {score}
      </div>
    </div>
  );
};

ScoreRing.propTypes = {
  score: PropTypes.number,
  color: PropTypes.string,
  size: PropTypes.number,
};

ScoreRing.defaultProps = {
  score: 0,
  color: 'var(--ds-success)',
  size: 54,
};

export default ScoreRing;
